import { Component, computed, inject, OnInit, viewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonToggle, MatButtonToggleGroup } from '@angular/material/button-toggle';
import { MatIconModule } from '@angular/material/icon';
import { MatDivider, MatListItem, MatListItemIcon, MatNavList } from '@angular/material/list';
import { MatDrawer, MatDrawerContainer, MatDrawerContent } from '@angular/material/sidenav';
import { RouterLink } from '@angular/router';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { InteractionStatus } from '@azure/msal-browser';
import { DarkModeService } from '@raxapp/appearance/dark-mode/dark-mode.service';
import { UserAccountService } from '@raxapp/user-accounts/user-account.service';
import { filter, take } from 'rxjs';
import { UsersUserSideMenuService } from './user-side-menu.service';

@Component({
    selector: 'rax-users-user-side-menu',
    imports: [
        MatDrawerContainer,
        MatDrawer,
        MatDrawerContent,
        MatNavList,
        MatListItem,
        MatIconModule,
        MatListItemIcon,
        MatDivider,
        MatButtonToggleGroup,
        MatButtonToggle,
        FormsModule,
        RouterLink,
    ],
    templateUrl: './user-side-menu.component.html',
})
export class UsersUserSideMenuComponent implements OnInit {
    private readonly userSideMenuService = inject(UsersUserSideMenuService);
    private readonly authService = inject(MsalService);
    private readonly msalBroadcastService = inject(MsalBroadcastService);
    private readonly darkModeService = inject(DarkModeService);
    private readonly userAccountService = inject(UserAccountService);

    public readonly darkModeIsEnabled = this.darkModeService.darkModeIsEnabled;
    public readonly userAccountDisplayName = this.userAccountService.displayName;
    public readonly userAccountEmail = this.userAccountService.email;
    public readonly showSetDebugAndDevButtons = computed(() => this.userAccountService.isSysAdmin());

    private readonly userMenuDrawer = viewChild.required<MatDrawer>('userMenuDrawer');

    ngOnInit(): void {
        this.userSideMenuService.setSideMenuIsOpenAction$.subscribe((open: boolean) => {
            if (open) {
                this.userMenuDrawer().open();
            } else {
                this.userMenuDrawer().close();
            }
        });
    }

    public onLogoutButtonClick(): void {
        this.msalBroadcastService.inProgress$
            .pipe(
                filter((status: InteractionStatus) => {
                    return status === InteractionStatus.None;
                }),
                take(1),
            )
            .subscribe(() => {
                this.authService.logoutRedirect({
                    account: this.authService.instance.getActiveAccount(),
                });
            });
    }
}
